module.exports = {
  "mpdi-0013": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "treatment"
      ]
    }
  }
};